import React, { useCallback, useEffect, useState } from "react";
import { Button, Card, Nav, Pagination, Table } from "react-bootstrap";
import { TableSkeleton } from "../../skeleton/TableSkeleton";
import {
  deleteAssetRow,
  deleteAssets,
  getAllAssetsData,
  getAssetColumns,
  getAssetRows,
  updateAssetRow,
  updateAssetsStatus,
} from "../../service/api";
import { MdDelete } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { showNotification } from "../../service/showNotification";
import { AssetRowPopup } from "./AssetRowPopup";
import { headerFields, specialStylingFields } from "./FieldsArray";
import { TiArrowSortedDown } from "react-icons/ti";
import { TiArrowSortedUp } from "react-icons/ti";
import { TiArrowUnsorted } from "react-icons/ti";
import { showPageNumbers } from "../../utils/table";
import { formatDate } from "../../utils/formatDate";
import { FaDeleteLeft } from "react-icons/fa6";
import SalesClearModal from "./SalesClearModal";
const dealNameId = "683eeb3d5a489901b765f98d",
  trancheTitleId = "683eeb3d5a489901b765f996",
  recordId = "683eeb3d5a489901b765f98b",
  billOfSaleSigned = "6842e5c1de64330232cc884e",
  trancheSold = "6842e5b3de64330232cc8849",
  entityName = "6842e6c0de64330232cc8862",
  clientName = "6842e59dde64330232cc8844",
  statusId = "6842e76cde64330232cc886a";

const isMobile = window.innerWidth < 800;
const AssetsTable = ({
  isNewUploaded,
  searchTerm,
  setTotalAssets,
  setAcceptedAssets,
  setPendingAssets,
  status,
  setIsAssetsLoading,
}) => {
  const [loading, setLoading] = useState(false);
  const [assets, setAssets] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalDocs, setTotalDocs] = useState(10);
  const [totalPages, setTotalPages] = useState(10);
  const [rowData, setRowData] = useState({});
  const [isEditClicked, setIsEditClicked] = useState(false);
  const [clearModal, setClearModal] = useState(false);
  const [clearId, setClearId] = useState(null);
  const [sort, setSort] = useState({
    [`${dealNameId}`]: 0,
    [`${trancheTitleId}`]: 0,
  });
  const [isColLoader, setIsColLoader] = useState(true);
  const [isRowLoader, setIsRowLoader] = useState(true);
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);

  const itemsPerPage = 10;
  const showPaginationNumbers = totalPages > 10;

  const deleteStyles = {
    marginRight: "10px",
    color: "red",
    fontSize: "1.2rem",
    cursor: "pointer",
  };
  const EditStyles = {
    color: "green",
    fontSize: "1.2rem",
    cursor: "pointer",
  };
  const cellWrapperStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
  };

  const clearStyles = {
    marginRight: "10px",
    color: "black",
    fontSize: "1.2rem",
    cursor: "pointer",
  };

  const buttonStyle = {
    position: "absolute",
    top: isMobile ? "272px" : "175px",
    right: "50px",

    transition: "opacity 0.3s ease",
    zIndex: "10",
  };

  const checkBoxStyle = {
    cursor: "pointer",
    padding: "12px 0px 12px 0px",
    position: "sticky",
  };

  // Style for special header fields
  const specialHeaderStyle = {
    color: "#356C58", // Dark green color for text (same as the edit button)
    fontWeight: "bold",
  };

  const stickyColumnHeaderStyle = {
    position: "sticky",
    top: "0",
    left: "0",
    zIndex: "3",
    background: "white",
  };
  const stickyColumnStyle = {
    position: "sticky",
    background: "white",
    left: 0,
    zIndex: "2",
  };

  const stickyColumnOddStyle = {
    background: "#f2f2f2",
    left: 0,
    zIndex: "2",
    position: "sticky",
  };

  const changeOrder = (header) => {
    const newOrder =
      sort[header._id] === 0 ? 1 : sort[header._id] === 1 ? -1 : 1;
    setSort((prev) => ({
      ...prev,
      [header._id]: newOrder,
    }));
  };

  // const fetchAssetsData = useCallback(async () => {
  //   setIsAssetsLoading(true);
  //   setLoading(true);
  //   try {
  //     const response = await getAllAssetsData(
  //       currentPage,
  //       itemsPerPage,
  //       searchTerm,
  //       sort["Deal Name"],
  //       sort["Tranche Title"],
  //       status
  //     );
  //     setAssets(response.data.assets);
  //     let totalPages;
  //     if (status == "Accepted") {
  //       totalPages = Math.ceil(response.data.acceptedDocs / itemsPerPage);
  //     } else if (status == "Pending") {
  //       totalPages = Math.ceil(response.data.pendingDocs / itemsPerPage);
  //     } else {
  //       totalPages = Math.ceil(response.data.totalDocs / itemsPerPage);
  //     }
  //     setTotalDocs(response.data.totalDocs);
  //     setTotalPages(totalPages);
  //     setTotalAssets(response.data.totalDocs);
  //     setAcceptedAssets(response.data.acceptedDocs);
  //     setPendingAssets(response.data.pendingDocs);
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     setLoading(false);
  //     setIsAssetsLoading(false);
  //   }
  // }, [currentPage, searchTerm, sort, status]);

  const handleEdit = async (item) => {
    //TODO - UPDATE WHOLE EDIT OPTION
    return;
    setRowData(item);
    setIsEditClicked(true);
  };

  const handleClear = async () => {
    const data = {
      billOfSaleSigned: null,
      trancheSold: null,
      entityName: null,
      clientName: null,
    };
    try {
      const response = await updateAssetRow(clearId, data);
      showNotification("success", "Sales Data Clear Successfully");
      // const resp = await fetchAssetsData();
    } catch (error) {
      showNotification("error", "Something went wrong");
    } finally {
      setClearModal(false);
      setClearId(null);
    }
  };

  const fetchAssetRows = async () => {
    const params = {
      page: currentPage,
      limit: itemsPerPage,
      searchTerm,
      sort,
      status,
    };
    try {
      // console.log("params", params);

      const response = await getAssetRows(params);

      const allRows = response?.data?.assets?.map((row) => {
        const isDisabled =
          row[billOfSaleSigned] === null &&
          row[trancheSold] === null &&
          row[entityName] === null &&
          row[clientName] === null;

        return {
          _id: row._id,
          ...row.assetData,
          createdAt: formatDate(new Date(row.createdAt)),
          updatedAt: formatDate(new Date(row.updatedAt)),
          action: (
            <div style={cellWrapperStyle}>
              <FaDeleteLeft
                style={{
                  marginRight: "10px",
                  color: isDisabled ? "#aaa" : "black",
                  fontSize: "1.2rem",
                  cursor: isDisabled ? "not-allowed" : "pointer",
                  pointerEvents: isDisabled ? "none" : "auto",
                  opacity: isDisabled ? 0.5 : 1,
                }}
                onClick={() => handleClearModalOpen(row)}
              />
              <MdDelete
                onClick={() => handleDelete(row._id)}
                style={deleteStyles}
              />
              <FaEdit onClick={() => handleEdit(row)} style={EditStyles} />
            </div>
          ),
        };
      });

      let totalPages;
      if (status == "Accepted") {
        totalPages = Math.ceil(response.data.acceptedDocs / itemsPerPage);
      } else if (status == "Pending") {
        totalPages = Math.ceil(response.data.pendingDocs / itemsPerPage);
      } else {
        totalPages = Math.ceil(response.data.totalDocs / itemsPerPage);
      }

      setRows(allRows);
      setTotalDocs(response.data.totalDocs);
      setTotalPages(totalPages);
      setTotalAssets(response.data.totalDocs);
      setAcceptedAssets(response.data.acceptedDocs);
      setPendingAssets(response.data.pendingDocs);
    } catch (err) {
      console.log("err", err);
      showNotification("error", "Failed to fetch asset data.");
    } finally {
      setIsRowLoader(false);
    }
  };

  const fetchAssetColumns = async () => {
    try {
      const { data } = await getAssetColumns();

      if (!data) throw new Error(`Asset column not found.`);

      const columns = data?.map((col) => ({
        _id: col._id,
        label: col.label,
        isSorting: [dealNameId, trancheTitleId].includes(col._id),
        isInfo: recordId === col._id,
        isZohoField: !!col?.isZohoField,
      }));

      columns.push(
        ...[
          {
            _id: "_id",
            label: "Asset Id",
            isSorting: false,
            isInfo: false,
            isZohoField: false,
          },
          {
            _id: "createdAt",
            label: "Created At",
            isSorting: false,
            isInfo: false,
            isZohoField: false,
          },
          {
            _id: "updatedAt",
            label: "Updated At",
            isSorting: false,
            isInfo: false,
            isZohoField: false,
          },
          {
            _id: "action",
            label: "Action",
            isSorting: false,
            isInfo: false,
            isZohoField: false,
          },
        ]
      );
      columns.unshift({
        _id: "__selection__",
        label: "Select",
        isSelection: true,
        isSticky: true,
      });
      // console.log(columns);
      setColumns(columns);
    } catch (err) {
      console.log("err", err);
      showNotification("error", "Failed to fetch asset columns.");
    } finally {
      setIsColLoader(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteAssetRow(id);
      showNotification("success", "Row deleted successfully");
      fetchAssetRows();
    } catch (error) {
      showNotification("Something went wrong");
    }
  };
  const [selectedRows, setSelectedRows] = useState([]);

  const toggleRowSelection = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const pendingRows = rows.filter((r) => r[statusId] === "Pending");

  const handleSelectAll = () => {
    const allPendingIds = pendingRows.map((r) => r._id);
    const areAllSelected = allPendingIds.every((id) =>
      selectedRows.includes(id)
    );

    if (areAllSelected) {
      // Deselect all
      setSelectedRows((prev) =>
        prev.filter((id) => !allPendingIds.includes(id))
      );
    } else {
      // Select all
      setSelectedRows((prev) =>
        Array.from(new Set([...prev, ...allPendingIds]))
      );
    }
  };

  const isAllSelected =
    selectedRows.length > 0 &&
    selectedRows.length === pendingRows.length &&
    pendingRows.length > 0;
  const handleBulkStatusUpdate = async () => {
    try {
      const response = await updateAssetsStatus(selectedRows, statusId);
      showNotification("success", "Selected asset's marked as Accepted");
      fetchAssetRows();
      setSelectedRows([]);
    } catch (error) {
      showNotification("error", "Status update failed, try again later.");
    }
  };

  const handleClearModalOpen = (asset) => {
    setClearModal(true);
    setClearId(asset?._id);
  };

  useEffect(() => {
    // fetchAssetsData();
    fetchAssetRows();
  }, [currentPage, isNewUploaded, searchTerm, sort, status]);

  //When the Status change it should move to the first page...
  useEffect(() => {
    setCurrentPage(1);
  }, [status]);

  useEffect(() => {
    fetchAssetColumns();
  }, []);

  return (
    <>
      {loading ? (
        <TableSkeleton />
      ) : (
        <div className="scrollable-table-container2 mx-3">
          {selectedRows.length > 0 && (
            <div>
              <Button
                onClick={handleBulkStatusUpdate}
                className="my-3"
                style={buttonStyle}
              >
                Mark Selected as Accepted
              </Button>
            </div>
          )}
          <Card
            border="light"
            className="table-wrapper table-responsive shadow-sm"
          >
            <Card.Body className="pt-0">
              <Table hover className="user-table align-items-center">
                <thead>
                  <tr>
                    {columns.map((header, index) => {
                      if (header._id === "__selection__") {
                        return (
                          <th key={index} style={stickyColumnHeaderStyle}>
                            {pendingRows.length > 0 && (
                              <input
                                type="checkbox"
                                style={checkBoxStyle}
                                checked={isAllSelected}
                                onChange={handleSelectAll}
                              />
                            )}
                          </th>
                        );
                      }

                      const isSortApplied = header?.isSorting;
                      const sortIcon =
                        sort[header._id] === 0 ? (
                          <TiArrowUnsorted color="grey" size={16} />
                        ) : sort[header._id] === 1 ? (
                          <TiArrowSortedDown size={16} />
                        ) : (
                          <TiArrowSortedUp size={16} />
                        );

                      // Apply special styling for the specified header fields
                      const headerStyle = header.isZohoField
                        ? specialHeaderStyle
                        : {};

                      return isSortApplied ? (
                        <th
                          key={index}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "14px 24px",
                            ...(header.isZohoField ? specialHeaderStyle : {}),
                          }}
                          onClick={() => changeOrder(header)}
                        >
                          {header.label}
                          {sortIcon}
                        </th>
                      ) : (
                        <th key={index} style={headerStyle}>
                          {header.label}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {!rows.length ? (
                    <tr>
                      <td className=" bg-grey" colSpan={100}>
                        No Records Found.
                      </td>
                    </tr>
                  ) : (
                    rows?.map((row, index) => (
                      <tr
                        key={row._id}
                        className={index % 2 === 0 ? "even-row" : "odd-row"}
                      >
                        {columns.map((col) => {
                          if (col.isSelection) {
                            return (
                              <td
                                key={col._id}
                                style={
                                  index % 2 === 0
                                    ? stickyColumnStyle
                                    : stickyColumnOddStyle
                                }
                              >
                                {row[statusId] === "Pending" && (
                                  <input
                                    type="checkbox"
                                    className={checkBoxStyle}
                                    checked={selectedRows.includes(row._id)}
                                    onChange={() => toggleRowSelection(row._id)}
                                  />
                                )}
                              </td>
                            );
                          }

                          return <td key={col._id}>{row[col._id] ?? "-"}</td>;
                        })}
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
              <Card.Footer className="px-3 border-0 d-lg-flex justify-content-between">
                <Nav>
                  <Pagination className="mb-2 mb-lg-0">
                    <Pagination.Prev
                      onClick={() =>
                        setCurrentPage((prev) => Math.max(prev - 1, 1))
                      }
                      disabled={currentPage === 1}
                    >
                      Previous
                    </Pagination.Prev>
                    {showPaginationNumbers && (
                      <>
                        {currentPage > 4 && (
                          <>
                            <Pagination.Item onClick={() => setCurrentPage(1)}>
                              1
                            </Pagination.Item>
                            <Pagination.Ellipsis disabled />
                          </>
                        )}
                        {[...Array(totalPages)].map((_, page) => {
                          if (showPageNumbers(page, currentPage, totalPages)) {
                            return (
                              <Pagination.Item
                                key={page + 1}
                                active={page + 1 === currentPage}
                                onClick={() => setCurrentPage(page + 1)}
                              >
                                {page + 1}
                              </Pagination.Item>
                            );
                          }
                          return null;
                        })}
                        {currentPage < totalPages - 3 && (
                          <>
                            <Pagination.Ellipsis disabled />
                            <Pagination.Item
                              onClick={() => setCurrentPage(totalPages)}
                            >
                              {totalPages}
                            </Pagination.Item>
                          </>
                        )}
                      </>
                    )}
                    <Pagination.Next
                      onClick={() =>
                        setCurrentPage((prev) =>
                          Math.min(
                            prev + 1,
                            Math.ceil(totalDocs / itemsPerPage)
                          )
                        )
                      }
                      disabled={currentPage === totalPages || totalPages === 0}
                    >
                      Next
                    </Pagination.Next>
                  </Pagination>
                </Nav>
              </Card.Footer>
            </Card.Body>
          </Card>
        </div>
      )}
      {isEditClicked && (
        <AssetRowPopup
          rowData={rowData}
          setIsEditClicked={setIsEditClicked}
          fetchAssetsData={() => {}}
        />
      )}

      {clearModal && (
        <SalesClearModal
          setShowClearModal={setClearModal}
          showClearModal={clearModal}
          handleClearModal={handleClear}
        />
      )}
    </>
  );
};

export default AssetsTable;
